// extracted by mini-css-extract-plugin
export default {"banner":"cookieConsent_banner__vOhkT","icon":"cookieConsent_icon__lmg0H","text":"cookieConsent_text__AjkYm","link":"cookieConsent_link__m0NvJ","button":"cookieConsent_button__bXW8Z"};